
// COMPONENTS
import chart_display from './chart-display/chart-display.js';
import chart_date_filter from './chart-date-filter/chart-date-filter.js'
import chart_dropdown_filter from './chart-dropdown-filter/chart-dropdown-filter.js'
import chart_display_panel from './chart-display-panel/chart-display-panel.js';

//DELETE LATER
import qrianalysispanelone from './temp-chart-panel/query-analysis-dashboard-panel-one/query-analysis-dashboard-panel-one.js';
import qrianalysispaneltwo from './temp-chart-panel/query-analysis-dashboard-panel-two/query-analysis-dashboard-panel-two.js';

export default [
	qrianalysispanelone,
	qrianalysispaneltwo,

	chart_date_filter,
	chart_dropdown_filter,
	chart_display,
	chart_display_panel
];
